import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { colors } from "../../constants/colors";
import { Link } from "react-router-dom";

// MUI components
import {
  AppBar, Toolbar, IconButton, Menu, MenuItem, FormControl, Select,
  CircularProgress, ListItemIcon, ListItemText, Button
} from '@material-ui/core';

// MUI Icons
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import StarIcon from '@material-ui/icons/Star';

// Actions
import {
  updateRange,
  logoutUser
} from "../../actions"

const Header = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  // console.log(props)

  const useStyles = makeStyles({
    root: {
      backgroundColor: colors.bkgDark,
      "& > div": {
        display: 'flex',
        justifyContent: 'space-between'
      },
    },
    right: {
      // padding: '10px',
      display: 'flex',
      alignItems: 'center'
    },
    rangeDropdown: {
      // margin: '10px',
      marginRight: '20px',
      '& .MuiSelect-root': {
        padding: '5px',
        paddingRight: '24px'
      }
    },
    loading: {
      backgroundColor: colors.red,
      margin: '10px',
      color: 'white',
      padding: '10px',
      marginLeft: '20px'
    },
    title: {
      fontSize: '2.5em'
    },
    svg: {
      cursor: 'pointer',
      '& polygon, & g, & path': {
        transition: 'all 0.3s ease'
      },
      '&:hover': {
        '& polygon, & g': {
          // fill: colors.teal
        },
        '& #v2': {
          transform: 'translate(-5px)',
        },
        '& #A': {
          transform: 'matrix(1, 0, 0, -1, -18, 49.224)'
        },
        '& #v3': {
          transform: 'translate(-31px)',
        },
        '& #svgEs #E': {
          transform: 'translate(-76px)',
        },
        '& #svgEs #S': {
          transform: 'translate(-114px)',
        },
        '& #mask': {
          transform: 'translate(-30px)',
        }
      }
    },
    svgEs: {
      transform: 'translate(125px, 5px)',
    }
  });

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = e => {
    // e.preventDefault();
    handleMenuClose()
    props.logoutUser();
  };

  const handleRangeChange = (event) => {
    props.updateRange(event.target.value)
  }

  const classes = useStyles();

  return(
    <AppBar position="static" className={classes.root}>
      <Toolbar>
        <Link to='/'>
          <svg xmlns="http://www.w3.org/2000/svg" width="205" height="49" viewBox="0 0 205 49" className={classes.svg}>
            <defs>
              {/* MASK */}
              <clipPath id="esMask">
                {/* <polygon points="109.634 39 123 0 0 0 0 38.992" /> */}
                <polygon id="mask" fillOpacity="0.5" points="101.634 48.5 117.357 .5 204.634 .5 204.634 48.49"/>
              </clipPath>

              <linearGradient id="myGradient" x1="50%" y1="0%" x2="50%" y2="100%" >
                <stop offset="0%" stopColor="rgb(255,255,255)" />
                <stop offset="100%" stopColor="#2b908f" />
              </linearGradient>
            </defs>

            {/* <rect x="0" y="0" height="50" width="200" fill="blue" clip-path="url(#esMask)" /> */}

            {/* ES */}
            <g clipPath="url(#esMask)">
              <g className={classes.svgEs} id='svgEs' fill="#FFF">
                <path id="S" d="M49.424,26.136 C49.424,27.2400055 49.6519977,28.187996 50.108,28.98 C50.5640023,29.772004 51.1519964,30.4199975 51.872,30.924 C52.5920036,31.4280025 53.4199953,31.7999988 54.356,32.04 C55.2920047,32.2800012 56.263995,32.4 57.272,32.4 C57.9920036,32.4 58.747996,32.3160008 59.54,32.148 C60.332004,31.9799992 61.0519968,31.7160018 61.7,31.356 C62.3480032,30.9959982 62.8879978,30.516003 63.32,29.916 C63.7520022,29.315997 63.968,28.5600046 63.968,27.648 C63.968,26.1119923 62.9480102,24.9600038 60.908,24.192 C58.8679898,23.4239962 56.0240182,22.6560038 52.376,21.888 C50.8879926,21.5519983 49.4360071,21.1560023 48.02,20.7 C46.6039929,20.2439977 45.3440055,19.6440037 44.24,18.9 C43.1359945,18.1559963 42.2480034,17.2200056 41.576,16.092 C40.9039966,14.9639944 40.568,13.5840082 40.568,11.952 C40.568,9.551988 41.0359953,7.58400768 41.972,6.048 C42.9080047,4.51199232 44.1439923,3.30000444 45.68,2.412 C47.2160077,1.52399556 48.9439904,0.9000018 50.864,0.54 C52.7840096,0.1799982 54.7519899,5.32907052e-14 56.768,5.32907052e-14 C58.7840101,5.32907052e-14 60.7399905,0.19199808 62.636,0.576 C64.5320095,0.96000192 66.2239926,1.60799544 67.712,2.52 C69.2000074,3.43200456 70.4359951,4.64399244 71.42,6.156 C72.4040049,7.66800756 72.991999,9.57598848 73.184,11.88 L63.464,11.88 C63.3199993,9.91199016 62.5760067,8.58000348 61.232,7.884 C59.8879933,7.18799652 58.3040091,6.84 56.48,6.84 C55.9039971,6.84 55.2800034,6.87599964 54.608,6.948 C53.9359966,7.02000036 53.3240028,7.1759988 52.772,7.416 C52.2199972,7.6560012 51.7520019,8.00399772 51.368,8.46 C50.9839981,8.91600228 50.792,9.52799616 50.792,10.296 C50.792,11.2080046 51.1279966,11.9519971 51.8,12.528 C52.4720034,13.1040029 53.3479946,13.5719982 54.428,13.932 C55.3730047,14.2470016 56.4374334,14.5344368 57.6213107,14.7943122 L58.136,14.904 C59.528007,15.1920014 60.9439928,15.5039983 62.384,15.84 C63.8720074,16.1760017 65.3239929,16.5839976 66.74,17.064 C68.1560071,17.5440024 69.4159945,18.179996 70.52,18.972 C71.6240055,19.764004 72.5119966,20.7479941 73.184,21.924 C73.8560034,23.1000059 74.192,24.5519914 74.192,26.28 C74.192,28.7280122 73.7000049,30.7799917 72.716,32.436 C71.7319951,34.0920083 70.4480079,35.423995 68.864,36.432 C67.2799921,37.440005 65.4680102,38.147998 63.428,38.556 C61.3879898,38.964002 59.3120106,39.168 57.2,39.168 C55.0399892,39.168 52.9280103,38.9520022 50.864,38.52 C48.7999897,38.0879978 46.964008,37.368005 45.356,36.36 C43.747992,35.351995 42.4280052,34.0200083 41.396,32.364 C40.3639948,30.7079917 39.8000005,28.6320125 39.704,26.136 L49.424,26.136 Z"/>
                <path id="E" d="M26.856,15.624 L10.224,15.624 C10.2720002,14.9039964 10.4279987,14.0880046 10.692,13.176 C10.9560013,12.2639954 11.4119968,11.4000041 12.06,10.584 C12.7080032,9.76799592 13.5719946,9.08400276 14.652,8.532 C15.7320054,7.97999724 17.0879918,7.704 18.72,7.704 C21.2160125,7.704 23.0759939,8.37599328 24.3,9.72 C25.5240061,11.0640067 26.3759976,13.031987 26.856,15.624 Z M10.224,22.104 L37.08,22.104 C37.272001,19.2239856 37.0320034,16.4640132 36.36,13.824 C35.6879966,11.1839868 34.5960076,8.83201032 33.084,6.768 C31.5719924,4.70398968 29.6400118,3.06000612 27.288,1.836 C24.9359882,0.61199388 22.1760158,5.32907052e-14 19.008,5.32907052e-14 C16.1759858,5.32907052e-14 13.5960116,0.50399496 11.268,1.512 C8.93998836,2.52000504 6.9360084,3.89999124 5.256,5.652 C3.5759916,7.40400876 2.28000456,9.479988 1.368,11.88 C0.45599544,14.280012 -1.13686838e-13,16.8719861 -1.13686838e-13,19.656 C-1.13686838e-13,22.5360144 0.44399556,25.175988 1.332,27.576 C2.22000444,29.976012 3.47999184,32.0399914 5.112,33.768 C6.74400816,35.4960086 8.73598824,36.8279953 11.088,37.764 C13.4400118,38.7000047 16.0799854,39.168 19.008,39.168 C23.2320211,39.168 26.8319851,38.2080096 29.808,36.288 C32.7840149,34.3679904 34.9919928,31.1760223 36.432,26.712 L27.432,26.712 C27.0959983,27.8640058 26.1840074,28.9559948 24.696,29.988 C23.2079926,31.0200052 21.4320103,31.536 19.368,31.536 C16.4879856,31.536 14.2800077,30.7920074 12.744,29.304 C11.2079923,27.8159926 10.3680007,25.4160166 10.224,22.104 Z"/>
              </g>
            </g>

            {/* VVAV */}
            <g fill="#FFF">

              {/* <polygon id="mask" fill-opacity="0.5" points="101.634 48.5 117.357 .5 204.634 .5 204.634 48.49"/> */}

              <polygon id="v3" points="112.928 43.232 125.528 6.008 115.376 6.008 107.528 31.424 107.384 31.424 99.536 6.008 88.808 6.008 101.552 43.232"/>
              <polygon id="A" points="86.12 43.224 98.72 6 88.568 6 80.72 31.416 80.576 31.416 72.728 6 62 6 74.744 43.224" transform="matrix(1 0 0 -1 0 49.224)"/>
              <polygon id="v2" points="58.76 43.232 71.36 6.008 61.208 6.008 53.36 31.424 53.216 31.424 44.72 6.008 34.64 6.008 47.384 43.232"/>
              <polygon points="24.12 43.232 36.72 6.008 26.568 6.008 18.72 31.424 18.576 31.424 10.728 6.008 0 6.008 12.744 43.232"/>



              {/* V3 */}
              {/* <polygon points="110.928 38.232 123.528 1.008 113.376 1.008 105.528 26.424 105.384 26.424 97.536 1.008 86.808 1.008 99.552 38.232"/> */}

              {/* A */}
              {/* <polygon points="84.12 38.224 96.72 1 86.568 1 78.72 26.416 78.576 26.416 70.728 1 60 1 72.744 38.224" transform="matrix(1 0 0 -1 0 39.224)" clip-path="url(#mask)" /> */}

              {/* V2 */}
              {/* <polygon fill-rule="nonzero" points="56.76 38.232 69.36 1.008 59.208 1.008 51.36 26.424 51.216 26.424 42.72 1.008 32.64 1.008 45.384 38.232"/> */}

              {/* V1 */}
              {/* <polygon points="25.12 38.232 37.72 1.008 27.568 1.008 19.72 26.424 19.576 26.424 11.728 1.008 1 1.008 13.744 38.232"/> */}
            </g>
          </svg>
        </Link>

        {/* <Typography variant="h6" className={classes.title}>
          vvaves
        </Typography> */}

        <div className={classes.right}>

          {/* LOADING */}
          { props.view.requestingData &&
            <CircularProgress color="primary" size={24} thickness={5} />
          }

          {/* RANGE Dropdown */}
          <FormControl className={classes.rangeDropdown}>
            {/* <InputLabel>Date Range</InputLabel> */}
            <Select
              value={props.view.range}
              onChange={handleRangeChange}
            >
              <MenuItem value={'5day'}>5 Day</MenuItem>
              <MenuItem value={'45day'}>45 Day</MenuItem>
            </Select>
          </FormControl>

          {/* Display login our logout button based on user logged in status */}
          {props.auth.isAuthenticated ?
            <React.Fragment>
              <IconButton color="inherit" aria-label="menu" edge="start" className={classes.menuButton} onClick={handleMenuClick}>
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem component={Link} to="/profile" onClick={handleMenuClose}>
                  <ListItemIcon>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText>Profile</ListItemText>
                </MenuItem>
                {props.user.admin &&
                  <MenuItem component={Link} to="/admin" onClick={handleMenuClose}>
                  <ListItemIcon>
                    <StarIcon />
                  </ListItemIcon>
                  <ListItemText>Admin</ListItemText>
                  </MenuItem>
                }
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText>Logout</ListItemText>
                </MenuItem>
              </Menu>
            </React.Fragment>
          :
          <Button color="inherit" component={Link} to="/login">
            Login
          </Button>
        }
        </div>
      </Toolbar>
    </AppBar>
  )
}


const mapDispatchToProps = {
  updateRange,
  logoutUser
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    user: state.user,
    view: state.view,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
